import React from "react";
import styled from "styled-components";
import { getBaseUrl } from "tr-web/apps/web/src/util/getBaseUrl";

export interface PublicationsProps {}

export function Publications() {
  const logos = [
    {
      filename: "brit-co.svg",
      alt: "Brit.co logo",
    },
    {
      filename: "marie-claire.svg",
      alt: "Marie Claire logo",
    },
    {
      filename: "refinery-29.svg",
      alt: "Refinery 29 logo",
    },
  ];

  return (
    <PublicationsContainer>
      {logos.map(({ filename, alt }, i) => {
        return (
          <Publication key={filename}>
            <img
              src={`${getBaseUrl()}v3/assets/static/homepage/publications/${filename}`}
              alt={alt}
              data-testid={`logo-${i}`}
            />
          </Publication>
        );
      })}
    </PublicationsContainer>
  );
}

export default Publications;

const PublicationsContainer = styled.div`
  display: none;

  ${(props) => props.theme.breakpoints.desktopUp} {
    height: 164px;
    display: flex;
    justify-content: center;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
`;

const Publication = styled.div`
  max-width: 300px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;

  & > img {
    width: 100%;
  }
`;
